define([
    'jquery',
    'lodash/object/assign',
    'lodash/function/bindAll',
    'lodash/lang/isObject',
    'lodash/function/defer',
    'openseadragon'
], function ($, assign, bindAll, isObject, defer, OpenSeadragon) {
    'use strict';

    var Zoomer = function (options) {
        var viewerOptions,
            viewerDataOpts;

        // Bind all methods to always have correct this val
        bindAll(this);

        options = assign({}, this.options, options);

        if (!options.$el instanceof $) {
            throw new Error('$el was not a jQuery obj: ' + options.$el);
        }
        if (options.$el.length === 0) {
            throw new Error('$el was empty');
        }

        this.$zoomerElement = options.$el.first();


        // Build options object to use when creating the Viewer. Default to
        // our default viewer options.
        viewerOptions = assign({}, this.getViewerDefaults());

        // Mix in options from our $el's data attribute if requested
        if (options.configureViewerFromDataAttribute) {
            viewerDataOpts = this.$zoomerElement.data('viewer-conf');

            // We require the data attr to be a JSON object
            if (!isObject(viewerDataOpts)) {
                throw new Error('data-viewer-conf attr did not contain an ' +
                    'object');
            }

            assign(viewerOptions, viewerDataOpts);
        }

        // Mix in any options provided to the constructor...
        assign(viewerOptions, options.viewerOptions);

        // Finally mix in settings implied by our state...
        assign(viewerOptions, {
            element: this.$zoomerElement[0]
        });

        this.viewerOptions = viewerOptions;
        this.initialize();
    };

    assign(Zoomer.prototype, {
        options: {
            $el: null,
            configureViewerFromDataAttribute: false,
            viewerOptions: {}
        },

        viewer: null,

        initialize: function () {
            // Create & start the OpenSeadragon viewer. Note that no image
            // content is loaded at this point, call openTileSource() to start
            // showing an image.
            this.viewer = new OpenSeadragon(this.viewerOptions);
        },

        getViewer: function () {
            return this.viewer;
        },

        openTileSource: function (tileSource) {
            this.getViewer().open(tileSource);
        },

        openTileSourceFromDataAttribute: function () {
            this._asyncLoadTileSourceFromDataAttr(this.openTileSource);
        },

        getViewerDefaults: function () {
            return {
                debugMode:  false,
                showNavigationControl: false,
                showNavigator: false,
                springStiffness: 3,
                animationTime: 0.7,
                minPixelRatio: 0.3,
                hash: '' + Math.random()
            };
        },

        /**
         * Load the tilesource specified by data-zoomerConf attribute on our
         * $zoomerElement. This is an async call, the loaded tile source will
         * be passed to the provided callback function.
         *
         * The data-tilesource-conf attr on this.$zoomerElement should contain
         * a JSON string with content in on of two forms:
         *
         * Hard coded values:
         * {
         *     "srcType": "HARD_CODED",
         *     "data": {
         *         "width": 2131,
         *         "height": 2858,
         *         "tileSize": 256,
         *         "tileOverlap": 1,
         *         "fileFormat": 'jpg',
         *         "displayRects": []
         *     },
         *     "tilesUrl": "http://cudl.lib.cam.ac.uk/content/images/PR-07743-B-00014-00109-000-00001_files/"
         * }
         *
         * Or a dzi URL to fetch the values from:
         * {
         *     "srcType": "URL",
         *     "dziUrl": "http://some.where/some/path/foo.dzi",
         *     "tilesUrl": "http://some.where.else/content/images/foo_files/"
         * }
         */
        _asyncLoadTileSourceFromDataAttr: function (callback) {
            var tilesourceConf,
                onTileSourceLoaded,
                hardCodedConf,
                tileSource;

            tilesourceConf = this.$zoomerElement.data('tilesource-conf');

            // Tile sources can either be defined by hard coded settings, or a
            // URL pointing to a DZI file with the same data (widths, heights
            // etc)
            if (tilesourceConf.srcType === 'HARD_CODED') {
                hardCodedConf = tilesourceConf.data;

                // Ensure the hard-coded data has the required fields
                if (!(hardCodedConf.width && hardCodedConf.height &&
                    hardCodedConf.tileSize && hardCodedConf.tileOverlap &&
                    hardCodedConf.fileFormat)) {

                    throw new Error('Hard coded Zoomer config data did have ' +
                        'all required params: ' + hardCodedConf);
                }

                // Create the tilesource from the hard-coded data.
                tileSource = {
                    Image: {
                        xmlns: 'http://schemas.microsoft.com/deepzoom/2008',
                        Url: tilesourceConf.tilesUrl,
                        Format: hardCodedConf.fileFormat,
                        TileSize: hardCodedConf.tileSize,
                        Size: {
                            Height: hardCodedConf.height,
                            Width: hardCodedConf.width
                        }
                    }
                };

                // Async call callback even though we already have
                // the tileSource loaded to be consistent with the async
                // URL fetching path below.
                defer(function() {
                    callback(tileSource);
                });

            } else if (tilesourceConf.srcType === 'URL') {

                // OpenSeadragon doesn't seem to allow tiles to live separatly
                // from the DZI files. As a workaround we fetch the DZI ourself
                // and manually specify a fake Url for the DZI which points to
                // our tiles.
                $.get(tilesourceConf.dziUrl)
                    .done(function(tileSource) {
                        tileSource.Image.Url = tilesourceConf.tilesUrl;
                        callback(tileSource);
                    })
                    .fail(function() {
                        console.error('Unable to load tilesource from: ' +
                                      tilesourceConf.dziUrl);
                    });
            }
        }
    });

    return {
        Zoomer: Zoomer
    };
});



/** WEBPACK FOOTER **
 ** ./js/view/components/Zoomer.js
 **/